import React, { FunctionComponent } from 'react';
import ChangeModel from '../../changeModel/ChangeModel';
import customise from '../../../../../constants/customise';
import VariantSelectorBase from '../variantSelectorBase/VariantSelectorBase';
import SpecPackListContainer from '../spacPackList/SpecPackListContainer';
import useSimpleSpecPackTrimLevel from '../../../../../../trimLevels/hooks/queries/useSimpleSpecPackTrimLevel';
import SpeckPackDataLayer from '../../../../../../common/utils/dataLayer/graphql/SpeckPackDataLayer';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';

export interface IModelContainerProps {
  selectedVariantId: string;
  changeVariant: (variantId: string) => void;
}

const SpecificationPackContainer: FunctionComponent<IModelContainerProps> = ({ selectedVariantId, changeVariant }) => {
  const variantName = customise.VARIANT_ITEM.name;
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const { data, loading: isLoadingVariants, error, trimLabelData } = useSimpleSpecPackTrimLevel();
  const specPacks = data?.specPacks || [];
  const modelName = trimLabelData?.trim?.attributes?.label || '';

  const onChangeVariant = (value: string) => {
    changeVariant(value);
    const dimension = dimensions;
    SpeckPackDataLayer({ specPacks, value, dimension });
  };

  return (
    <VariantSelectorBase sectionName={variantName} error={error}>
      <ChangeModel variant={'caption'} align={'left'} sectionName={variantName} />
      <SpecPackListContainer
        selectedVariantId={selectedVariantId}
        changeVariant={onChangeVariant}
        specPacks={specPacks}
        isLoadingVariants={isLoadingVariants}
        modelName={modelName}
      />
    </VariantSelectorBase>
  );
};

export default SpecificationPackContainer;
